<template>
  <div>
    <b-button
      id="btn-excel"
      ref="btnexcel"
      variant="primary"
      size="sm"
      style="
        margin-right: 1%;
        background: #37ef00 !important;
        border-color: #37ef00 !important;
      "
      @click="cargarReporte((excel_btn = '1'))"
    >
      <font-awesome-icon icon="fa-solid fa-file-excel" />
    </b-button>
    <b-button
      id="btn-pdf"
      variant="danger"
      size="sm"
      @click="cargarReporte((excel_btn = ''), (pdf_btn = '1'))"
    >
      <font-awesome-icon icon="fa-solid fa-file-pdf" />
    </b-button>
    <b-card-code class="principal mt-2">
      <b-row class="mt-2">
        <b-col md="4">
          <b-form-group>
            <label for="fecha-desde">Fecha (desde): </label>
            <flat-pickr
              v-model="fecha_desde"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha desde..."
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="fecha-hasta">Fecha (hasta): </label>
            <flat-pickr
              v-model="fecha_hasta"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha hasta..."
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" class="pb-2">
          <b-button variant="primary" size="sm" @click="filtrar">
            <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Consultar
          </b-button>
        </b-col>
      </b-row>
    </b-card-code>
    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card-code class="mt-1">
        <b-card-title class="mb-1 text-center">
          Reporte operativo
        </b-card-title>
        <div id="chart">
          <vue-apex-charts
            type="bar"
            height="350"
            :options="chartOptions"
            :series="series"
            ref="barStackedChart"
          ></vue-apex-charts>
        </div>
      </b-card-code>
      <b-card-code class="mt-1">
        <b-table
          v-if="items_reporte.length > 0"
          bordered
          striped
          responsive
          :small="true"
          :items="items_reporte"
          :fields="fields_reporte"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :tbody-tr-class="rowClass"
          class="mb-1"
        >
          <template #cell(total_bus)="data">
            <a style="font-weight: bold">{{ data.value }}</a>
          </template>
        </b-table>
        <div v-else class="text-center">
          <p>No se encontraron registros</p>
        </div>
      </b-card-code>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCardSubTitle,
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BCardHeader,
  BTooltip,
  BCardGroup,
  VBTooltip,
  BOverlay,
} from "bootstrap-vue";
import vSelect from "vue-select";
import VueApexCharts from "vue-apexcharts";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
// import apexChatData from '@/views/charts-and-maps/charts/apex-chart/apexChartData'
import BCardCode from "@core/components/b-card-code";
import axios from "@/libs/axios";
import $ from "jquery";
import { $themeColors } from "@themeConfig";
import actions from "@/assets/utils/utils";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import Vue from "vue";

export default {
  components: {
    VueApexCharts,
    VueSimpleSuggest,
    ValidationProvider,
    ValidationObserver,
    BCardGroup,
    BTooltip,
    BCard,
    BCardTitle,
    BCardSubTitle,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardHeader,
    BCardBody,
    flatPickr,
    vSelect,
    BOverlay,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      login_user: "",
      fields_reporte: [
        {
          key: "bus",
          label: "Bus",
          sortable: true,
          thClass: "text-center",
          label_completo: "Bus",
          thStyle: { width: "12%" },
        },
        {
          key: "residentes_permanentes",
          label: "Residente permanente",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
          label_completo: "Residente permanente",
        },
        {
          key: "residentes_temporales",
          label: "Residente temporal",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
          label_completo: "Residente temporal",
        },
        {
          key: "residentes_concesionario",
          label: "Concesionario temporal",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
          label_completo: "Concesionario temporal",
        },
        {
          key: "total_guia_residente_permanente",
          label: "Guia - Residente permanente",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
          label_completo: "Guia - Residente permanente",
        },
        {
          key: "boleto_normal_media_tarifa",
          label: "Media tarifa",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
          label_completo: "Media tarifa",
        },
        {
          key: "boleto_normal_tarifa_completa",
          label: "Tarifa normal",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
          label_completo: "Tarifa normal",
        },
        {
          key: "boleto_roundtrip_media_tarifa",
          label: "Roundtrip MT",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
          label_completo: "Roundtrip media tarifa",
        },
        {
          key: "boleto_roundtrip_tarifa_completa",
          label: "Roundtrip TN",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
          label_completo: "Roundtrip tarifa normal",
        },
        // {
        //   key: "boleto_oneway_tarifa_completa",
        //   label: "Oneway TN",
        //   sortable: true,
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   label_completo: "Oneway tarifa normal",
        // },
        {
          key: "tarifa_operadora",
          label: "Operadora",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
          label_completo: "Operadora",
        },
        {
          key: "donativo",
          label: "Donativo",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
          label_completo: "Donativo",
        },
        {
          key: "tickets_ecommerce",
          label: "Tickets Ecommerce",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
          label_completo: "Tickets Ecommerce",
        },
        {
          key: "tickets_tarjeta",
          label: "Tickets Tarjetas",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
          label_completo: "Tickets Tarjetas",
        },
        {
          key: "tickets_pos",
          label: "Tickets POS Web",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
          label_completo: "Tickets POS Web",
        },
        {
          key: "total_bus",
          label: "Tot.",
          sortable: true,
          thClass: "text-right",
          tdClass: "text-right",
          label_completo: "Total bus",
        },
      ],
      items_reporte: [],

      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        { key: "lote", label: "Lote", sortable: true },
        { key: "boleto", label: "Boleto", sortable: true },
        { key: "city", label: "Nombre", sortable: true },
        { key: "trayecto", label: "Trayecto", sortable: true },
        { key: "post", label: "Bus", sortable: true },
      ],
      items: [],
      mostrarLoader: false,
      fecha_desde: new Date().toLocaleString("pt-BR").split(", ")[0],
      fecha_hasta: new Date().toLocaleString("pt-BR").split(", ")[0],
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "d/m/Y",
        locale: Spanish,
      },

      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        title: {
          text: "",
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: function (val) {
              return val;
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },

        colors: [
          "#6CADDF",
          "#E194BC",
          "#FAB26A",
          "#AE77B2",
          "#F27077",
          "#9DD374",
          "#DA8868",
          "#DC69AA",
          "#6978AA",
          "#939393",
        ],
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.comprobarPermisos();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
    // this.cargarCantidadxTipoPasajero()
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    // this.cargarCantidadMarcacionXAnio()
    this.cargarReporte();
    $("#contenedor-botones").append($("#btn-excel")).append($("#btn-pdf"));
  },
  methods: {
    comprobarPermisos() {
      if (localStorage.getItem("permisos").indexOf("rep_reporte_operativo") === -1) {
        this.$router.push({ name: "not-permitted" });
      }
    },
    filtrar() {
      this.cargarReporte();
    },
    cargarReporte(excel_btn = "", pdf_btn = "") {
      this.mostrarLoader = true;
      axios
        .post("api", {
          query: `query getReporteOperativo($fechaDesde: String!, $fechaHasta: String!, $excel: String!, $pdf: String!) {
                    getReporteOperativo(fechaDesde: $fechaDesde, fechaHasta: $fechaHasta, excel: $excel, pdf: $pdf) {
                        reporteOpera {
                            bus,
                            tarifa_residentes: tarifaResidentes,
                            residentes_permanentes: residentesPermanentes,
                            residentes_temporales: residentesTemporales,
                            residentes_concesionario: residentesConcesionario,
                            total_guia_residente_permanente: totalGuiaResidentePermanente,
                            media_tarifa: mediaTarifa,
                            boleto_normal_media_tarifa: boletoNormalMediaTarifa,
                            boleto_normal_tarifa_completa: boletoNormalTarifaCompleta,
                            boleto_roundtrip_media_tarifa: boletoRoundtripMediaTarifa,
                            boleto_roundtrip_tarifa_completa: boletoRoundtripTarifaCompleta,
                            boleto_oneway_tarifa_completa: boletoOnewayTarifaCompleta,
                            tarifa_operadora: tarifaOperadora,
                            donativo,
                            tickets_ecommerce: ticketsEcommerce,
                            tickets_tarjeta: ticketsTarjeta,
                            tickets_pos: ticketsPos,
                            total_bus: totalBus,
                        },
                        reporteparagrafica {
                            nombresBuses: nombresBuses,
                            tarifasCantidades {
                                residentesPermanentes {
                                    nombre,
                                    cantidades,
                                },
                                residentesTemporales {
                                    nombre,
                                    cantidades,
                                },
                                residentesConcesionario {
                                    nombre,
                                    cantidades,
                                },
                                totalGuiaResidentePermanente {
                                    nombre,
                                    cantidades,
                                },
                                boletoNormalMediaTarifa {
                                    nombre,
                                    cantidades,
                                },
                                boletoNormalTarifaCompleta {
                                    nombre,
                                    cantidades,
                                },
                                boletoRoundtripMediaTarifa {
                                    nombre,
                                    cantidades,
                                },
                                boletoRoundtripTarifaCompleta {
                                    nombre,
                                    cantidades,
                                },
                                tarifaOperadora {
                                    nombre,
                                    cantidades,
                                },
                                donativo {
                                    nombre,
                                    cantidades,
                                },
                                ticketsEcommerce{
                                    nombre,
                                    cantidades,
                                },
                                ticketsTarjeta{
                                    nombre,
                                    cantidades,
                                },
                                ticketsPos{
                                    nombre,
                                    cantidades,
                                }
                            },
                        },
                        dataarchivo,
                        status,
                        message,
                    }
                }`,
          variables: {
            fechaDesde: this.fecha_desde,
            fechaHasta: this.fecha_hasta,
            excel: excel_btn,
            pdf: pdf_btn,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getReporteOperativo.status === "success") {
              if (response.data.data.getReporteOperativo.reporteOpera) {
                if (
                  response.data.data.getReporteOperativo.reporteOpera.length !==
                  0
                ) {
                  this.items_reporte =
                    response.data.data.getReporteOperativo.reporteOpera;
                  this.items_reporte[this.items_reporte.length - 1]["status"] =
                    "negrita";
                } else {
                  this.items_reporte = [];
                }
              } else {
                var data = response.data.data.getReporteOperativo.dataarchivo;
                if (excel_btn === "1") {
                  actions.cargarArchivos(
                    data,
                    "Reporte Operativo.xlsx",
                    "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64"
                  );
                } else {
                  actions.cargarArchivos(
                    data,
                    "Reporte Operativo.pdf",
                    "data:application/pdf;base64"
                  );
                }
              }
              if (response.data.data.getReporteOperativo.reporteparagrafica) {
                let customSeries = [];
                let reporte =
                  response.data.data.getReporteOperativo.reporteparagrafica
                    .tarifasCantidades;
                for (var key in reporte) {
                  let tarifa = {
                    name: reporte[key]["nombre"],
                    data: reporte[key]["cantidades"],
                  };
                  customSeries.push(tarifa);
                }
                this.$refs.barStackedChart.updateOptions({
                  series: customSeries,
                  xaxis: {
                    categories:
                      response.data.data.getReporteOperativo.reporteparagrafica
                        .nombresBuses,
                  },
                });
              } else {
                let customSeries = [];
                this.$refs.barStackedChart.updateOptions({
                  series: customSeries,
                  xaxis: {
                    categories: [],
                  },
                });
              }
            }
          }
          this.mostrarLoader = false;
        });
    },
    rowClass(item, type) {
      const styleClass = "last-row";
      if (!item || type !== "row") {
        return;
      }

      // eslint-disable-next-line consistent-return
      if (item.status === "negrita") {
        return styleClass;
      }
    },
    setToken() {
      const usuarioCookie = this.$cookie.get("usuario");
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie);
        this.login_user = user.username;
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style>
.text-red {
  color: red;
}
.last-row {
  font-weight: bold !important;
}
.principal .card-header {
  display: none !important;
}
.principal .card-body {
  padding-bottom: 0 !important;
}
[dir] .table th,
[dir] .table td {
  padding-left: 1%;
  padding-right: 1%;
}
</style>
